import React from "react";

import LatestNewsSection from "../elements/latest-news-slider";
import { ContactSection } from "../elements/contact-section";
import ConferenceMarketingBanner from "../elements/conference-marketing/main-banner";
import { ConferenceMarketingDetail } from "../elements/conference-marketing/detail";
import ConferenceMarketingServicesDetails from "../elements/conference-marketing/services-slider";
import HCPConferencesSliderSection from "../elements/hcp-marketing/conferences-slider";
import { Conferences } from "../elements/hcp-marketing/conferences";
function ConferenceMarketing() {
  return (
    <>
      <ConferenceMarketingBanner />
      {ConferenceMarketingDetail}
      <ConferenceMarketingServicesDetails />
      <Conferences />
      <HCPConferencesSliderSection />
      <LatestNewsSection />
      <ContactSection />
    </>
  );
}

export default ConferenceMarketing;
